import { SentryService } from '~/lib/services/sentry-service'
import { defineServiceComposable } from '~/composables/service-container'

export const useSentryService = defineServiceComposable('sentry', (nuxtApp) => new SentryService(nuxtApp))
